       
import { RouteName } from './routenames';
import { Video } from './types';
import loadjs from 'loadjs';
import { getGlobalVideojsPath, prepareVideoSrc } from "../api";
import { options } from "./../common/videooptions";

export default {
    components: {

    },

    data() {
        var video = null;
        if(this.data.Videos.length == 1) {
            video = this.data.Videos[0];
        }
        return {
            poster: "",
            video: video,
            player: null,
        }
    },

    props: {
        data: {
            type: Object,
            required: true
        },
    },

    methods: {
        loadSwiper() {
            var self = this;
            if(!self.$refs.swiper) {
                return;
            }
            new Swiper(self.$refs.swiper, {
                slidesPerView: 1,
                spaceBetween: 18,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                breakpoints: {
                    480: {
                        grid: {
                            rows: 2,
                            fill: 'row',
                        },
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        grid: {
                            rows: 2,
                            fill: 'row',
                        },
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        spaceBetween: 18,
                    },
                },
                pagination: {
                    el: self.$refs.pagination,
                    dynamicBullets: true,
                    dynamicMainBullets: 4,
                    clickable: true,
                },
            });
        },

        openVideo(video: Video) {
            this.$router.push({
                name: RouteName.VideoRoute,
                params: {
                    seoname: video.SeoName,
                    categoryid: this.data.Id,
                },
            });
        },

        initVideo() {
            if(this.data.Videos.length != 1) {
                return;
            }
            if(!loadjs.isDefined('videojs')) {
                loadjs([getGlobalVideojsPath()], 'videojs');
            }
            var self = this;

            loadjs.ready('videojs', function(){
                var videoOptions = JSON.parse(JSON.stringify(options));
                videoOptions.controls = false;
                videoOptions.muted = true;
                videoOptions.loop = true;
                self.player = videojs(self.$refs.video, videoOptions).ready(function(){
                    this.muted(true);
                    this.src(prepareVideoSrc(self.data.Videos[0].Src));
                });
            });
        },

        unescape(html) {
            const div = document.createElement('div');
            div.innerHTML = html;
            return div.textContent || div.innerText;
        }
    },

    mounted() {
        this.loadSwiper();
        this.initVideo();
    },

    unmounted() {
        if(this.player) {
            this.player.dispose();
        }
    }
}
